import React from "react";
import PropTypes from "prop-types";

import withStyles from '@mui/styles/withStyles';

import QualificationComponent from './QualificationComponent';
import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import QualificationAccordionSummary from './QualificationAccordionSummary';
import Typography from '@mui/material/Typography';


import { GarantieTypeNoms } from 'constants.js';

import Datetime from 'components/Shared/Datetime';


const styles = theme => ({
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    },

    formControl: {
        margin: theme.spacing(1)
    },

    group: {
        margin: theme.spacing(1, 0)
    },
    heightLabel: {
        height: '30px'
    },
});



class SavByFoussierGarantieCalculee extends QualificationComponent {


    constructor(props) {
        super(props);


        this.state = {
            ...this.state,

            [ReclamationQualificationDetailCodes.SavByFoussierGarantieCalculee]: props.garantie,
        };

        this.generableCodes = [
            ReclamationQualificationDetailCodes.SavByFoussierGarantieCalculee,
            ReclamationQualificationDetailCodes.SavByFoussierDateFinGarantieCalculee,
        ];
    }





    componentDidMount() {
        const { name } = this.props;
        const { position, toAdd, toDelete } = this.getQualificationData(this.state);

        this.props.onChange(name, position, toAdd, toDelete, "Mount");
    }



    componentDidUpdate(prevProps) {
        const { name } = this.props;

        if (prevProps.garantie !== this.props.garantie || prevProps.dateFinGarantie !== this.props.dateFinGarantie) {

            let newState = {
                ...this.state,
                [ReclamationQualificationDetailCodes.SavByFoussierGarantieCalculee]: this.props.garantie,
            };


            this.setState(newState);

            const { position, toAdd, toDelete } = this.getQualificationData(newState);

            this.props.onChange(name, position, toAdd, toDelete, "Mount");

        }
    }




    getQualificationData(newState) {

        // Préparation des codes à supprimer (tous les codes générables)
        let toDelete = [...this.generableCodes];



        let toAdd = [];


        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.SavByFoussierDateFinGarantieCalculee,
            type: ReclamationQualificationDetailType.Date,
            libelle: "Date de fin de garantie de l'article",
            valeurDate: this.props.dateFinGarantie !== null ? new Date(this.props.dateFinGarantie) : null,

        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierDateFinGarantieCalculee);

        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.SavByFoussierGarantieCalculee,
            type: ReclamationQualificationDetailType.ChoixSimple,
            libelle: "État théorique de la garantie",
            valeurInteger: newState[ReclamationQualificationDetailCodes.SavByFoussierGarantieCalculee],
            valeurString: GarantieTypeNoms[newState[ReclamationQualificationDetailCodes.SavByFoussierGarantieCalculee]]

        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierGarantieCalculee);




        return {
            name: newState.name,
            position: this.props.position,
            toAdd: toAdd,
            toDelete: toDelete
        }
    }


    render() {
        const { name } = this.props;

        let dateFinGarantieCalculee = this.props.dateFinGarantie !== null ? new Date(this.props.dateFinGarantie) : null;

        return (


            <Accordion id={name} defaultExpanded={true} elevation={3}>

                <QualificationAccordionSummary title="Calcul de la garantie" />

                <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>

                    <Typography>
                        {`Date de fin de garantie de l'article : `}
                        {dateFinGarantieCalculee !== null && (<Datetime withTooltip datetime={dateFinGarantieCalculee} />)}
                        {dateFinGarantieCalculee === null && (<span>N/A</span>)}
                    </Typography>

                    <Typography>{`État théorique de la garantie : ${GarantieTypeNoms[this.state[ReclamationQualificationDetailCodes.SavByFoussierGarantieCalculee]]}`}</Typography>


                </AccordionDetails>
            </Accordion>


        );
    }

}


SavByFoussierGarantieCalculee.propTypes = {
    name: PropTypes.string.isRequired
};

//SavByFoussierExtensionGarantie.defaultProps = {
//};

export default withStyles(styles)(SavByFoussierGarantieCalculee);